import { queryOptions, useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface AverageAttendance {
  averageAttendance: number;
  averageAbsentPercent: number;
}

export interface GetAverageAttendanceParams {
  sessionId?: string;
}

export const getAverageAttendanceAPI = async (
  params: GetAverageAttendanceParams,
) => {
  const response = await baseAPI.get<AverageAttendance>(
    `/dashboard/average-attendance/${params.sessionId}`,
  );
  return response.data;
};

export const getAverageAttendanceQueryOptions = (
  params: GetAverageAttendanceParams,
) =>
  queryOptions({
    queryKey: [KEYS.AVERAGE_ATTENDANCE, params],
    queryFn: () => getAverageAttendanceAPI(params),
    enabled: !!params.sessionId,
  });

export const useGetAverageAttendance = (params: GetAverageAttendanceParams) => {
  return useQuery(getAverageAttendanceQueryOptions(params));
};
